export const CSS_CLASSES = {
	ICON: 'notification-icon',
	CARD: 'notification-icon__card',
	CARD_EMPTY: 'notification-icon__card--empty',
	LIST: 'notification-icon__card__list',
	LIST_ITEM_TEXT: 'notification-icon__card__list__list-item__text',
};
